/* ═══════════════════════════════════════════════════════
   RO|OT — FAQ / Customer Service Page JS
   Style: The Apothecary (Mockup 2)
   File: faq2-script.js
   Add before </body> in Shopify theme
════════════════════════════════════════════════════════ */

document.addEventListener('DOMContentLoaded', function () {

  /* ── Accordion ── */
  const items = document.querySelectorAll('.faq2-item');

  items.forEach(function (item) {
    const header = item.querySelector('.faq2-header');
    const body   = item.querySelector('.faq2-body');

    header.addEventListener('click', function () {
      const isOpen = item.classList.contains('active');

      // Close all open items first
      items.forEach(function (other) {
        if (other.classList.contains('active')) {
          other.classList.remove('active');
          other.querySelector('.faq2-body').style.maxHeight = '0';
        }
      });

      // If it wasn't open, open it now
      if (!isOpen) {
        item.classList.add('active');
        body.style.maxHeight = body.scrollHeight + 'px';
      }
    });
  });


  /* ── Nav pill active state on scroll ── */
  const sections  = document.querySelectorAll('.faq2-section');
  const navPills  = document.querySelectorAll('.faq2-nav-pill');

  function setActivePill() {
    let current = '';

    sections.forEach(function (section) {
      const sectionTop = section.getBoundingClientRect().top;
      if (sectionTop <= 120) {
        current = section.getAttribute('id');
      }
    });

    navPills.forEach(function (pill) {
      pill.classList.remove('active');
      // Match pill href to section id
      if (pill.getAttribute('href') === '#' + current) {
        pill.classList.add('active');
      }
    });
  }

  window.addEventListener('scroll', setActivePill, { passive: true });
  setActivePill(); // run once on load


  /* ── Smooth scroll for nav pills ── */
  navPills.forEach(function (pill) {
    pill.addEventListener('click', function (e) {
      e.preventDefault();
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        const offset = 80; // account for sticky nav height
        const top = target.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top: top, behavior: 'smooth' });
      }
    });
  });

});